import { Injectable } from '@angular/core';
import { OCPPService } from './ocpp.service';
import { HttpClient } from '@angular/common/http';
import { SetChargingProfileRequest } from '../models/SetChargingProfileRequest';
import { ClearChargingProfileRequest } from '../models/ClearChargingProfileRequest';
import { GetCompositeScheduleRequest } from '../models/GetCompositeScheduleRequest';

@Injectable()
export class SmartChargingService extends OCPPService {

    private SET_CHARGING_PROFILE_ENDPOINT = '/set-charging-profile';
    private CLEAR_CHARGING_PROFILE_ENDPOINT = '/clear-charging-profile';
    private GET_COMPOSITE_SCHEDULE_ENDPOINT = '/get-composite-schedule';

    getProfileBasePath(): string {
        return '/operations/smart-charging';
    }

    constructor(private http: HttpClient) {
        super();
    }

    public setChargingProfile(data: SetChargingProfileRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.SET_CHARGING_PROFILE_ENDPOINT, data);
    }

    public clearChargingProfile(data: ClearChargingProfileRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.CLEAR_CHARGING_PROFILE_ENDPOINT, data);
    }

    public getCompositeSchedule(data: GetCompositeScheduleRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.GET_COMPOSITE_SCHEDULE_ENDPOINT, data);
    }
}


